import { Select } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

import styles from './styles.module.css';

const CustomSelect = (props: any) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    const handleTouchMove = (e: Event) => {
        (e as TouchEvent).stopPropagation();
    };

    useEffect(() => {
        const dropdownElement = ref.current?.querySelector('.rc-virtual-list-holder');

        if (dropdownElement && isDropdownOpen) {
            dropdownElement.addEventListener('touchmove', handleTouchMove, { passive: false });
        }
        return () => {
            if (dropdownElement) {
                dropdownElement.removeEventListener('touchmove', handleTouchMove);
            }
        };
    }, [isDropdownOpen]);
    return (
        <div className={styles.wrapper} ref={ref}>
            <Select {...props} onOpenChange={(open: boolean) => setIsDropdownOpen(open)} />
        </div>
    );
};

export default CustomSelect;
